<template>
  <div class="action-buttons flex items-center gap-2">
    <template v-for="action of actions">
      <el-dropdown
        v-if="action.type === 'dropdown'"
        trigger="click"
        :key="action.command || action.label"
        @command="(cmd) => handleAction(cmd, action)"
      >
        <el-button size="mini" class="el-dropdown-link cursor-pointer">
          <i :class="action.icon"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item of action.items"
            :key="item.command"
            :command="item.command"
            :divided="item.divided"
            :style="item.color ? { color: item.color } : {}"
          >
            <i v-if="item.icon" :class="item.icon + ' mr-2'" />{{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        v-else-if="action.type === 'button'"
        :key="action.command"
        size="mini"
        :type="action.buttonType || 'default'"
        :style="action.color ? { color: action.color } : {}"
        @click="handleAction(action.command, action)"
      >
        <i v-if="action.icon" :class="action.icon + ' mr-2'" />{{
          action.label
        }}
      </el-button>
      <el-dropdown-item
        v-else-if="action.type === 'command'"
        :key="action.command"
        :command="action.command"
        :divided="action.divided"
        :style="action.color ? { color: action.color } : {}"
        @click.native="handleAction(action.command, action)"
      >
        <i v-if="action.icon" :class="action.icon + ' mr-2'" />{{
          action.label
        }}
      </el-dropdown-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "ActionButtons",
  emits: ["command"],
  props: {
    /**
     * 示例 actions 数据:
     * ```js
     * [
     *   {
     *     type: 'button',
     *     label: '编辑',
     *     command: 'edit',
     *     icon: 'el-icon-edit',
     *     buttonType: 'primary'
     *   },
     *   {
     *     type: 'dropdown',
     *     label: '更多',
     *     icon: 'el-icon-more',
     *     items: [
     *       { label: '删除', command: 'delete', icon: 'el-icon-delete', color: '#F56C6C', divided: true },
     *       { label: '复制', command: 'copy', icon: 'el-icon-document-copy' }
     *     ]
     *   }
     * ]
     * ```
     */
    actions: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleAction(command, action) {
      this.$emit("command", { command, action, item: this.item });
    },
  },
};
</script>
